import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import CreepingProgressBar from '../../../../../../../../../../../../../../../components/CreepingProgressBar';
import { FailedGptRequestStatuses, GptRequestStatuses } from '../../../../../../../../../../../../../../../constants/gptRequestStatuses';
import { useGptRequest } from '../../../../../../../../../../../../../../../services/gpt-request-service';

const ScanningProgressBarModal = ({
  gptRequestId = null,
  onFail,
  onSuccess,
  onClose
}) => {
  const [isSettled, setIsSettled] = useState(false);
  const settledRef = useRef(false);

  const { data: gptRequest } = useGptRequest({ gptRequestId });

  useEffect(() => {
    if (settledRef.current || !gptRequest) return;

    if (FailedGptRequestStatuses.includes(gptRequest.status)) {
      settledRef.current = true;
      setIsSettled(true);
      onFail(gptRequest);
      return;
    }

    if ([GptRequestStatuses.Completed, GptRequestStatuses.Published].includes(gptRequest.status)) {
      settledRef.current = true;
      setIsSettled(true);
      onSuccess(gptRequest);
    }
  }, [gptRequest]);

  // dismissed via the modal close button before the request settled: give the caller a chance to cancel
  useEffect(() => () => {
    if (!settledRef.current) onClose(gptRequestId);
  }, []);

  return <CreepingProgressBar isComplete={isSettled} label="Scanning document..." />;
};

ScanningProgressBarModal.propTypes = {
  gptRequestId: PropTypes.number,
  onFail: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ScanningProgressBarModal;
